import {Injectable} from '@angular/core';
import {Route, Router, UrlSegment, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthStore} from '../stores/auth.store';
import {AuthHttpService} from '../http/auth.http';

@Injectable()
export class AdminOrManagerGuard  {
    constructor(private router: Router, private authStore: AuthStore, private http: AuthHttpService) { }
    guard(url: string): Observable<boolean | UrlTree> {
      return new Observable<boolean | UrlTree>((observer) => {
        const parsedUrl = this.router.getCurrentNavigation()?.initialUrl;
        const queryParams = parsedUrl?.queryParamMap;
        const queryParamsObj: Record<string, string> = {};

        queryParams?.keys.forEach(key => {
          queryParamsObj[key] = queryParams!.get(key) || '';
        });

        queryParamsObj['next'] = url;

        if (this.authStore.initalRequest) {
          if (this.authStore.isUser(3)) {
            observer.next(true);
            observer.complete();
          } else {
            observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
            observer.complete();
          }
        } else {
          this.http.getCurrent().subscribe((val) => {
            if (typeof val === 'string') {
              this.authStore.userInfo = this.authStore.noAuth;
              return;
            }
            this.authStore.userInfo = val.user;
            if (this.authStore.isUser(3)) {
              observer.next(true);
              observer.complete();
            } else {
              observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
              observer.complete();
            }
          }, (error) => {
            observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
            observer.complete();
          });
        }
      });
    }
    canMatch = (route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> => {
        return this.guard(segments.join('/'));
    };
}

@Injectable()
export class AdminGuard  {
    constructor(private router: Router, private authStore: AuthStore, private http: AuthHttpService) { }
    guard(url: string): Observable<boolean | UrlTree> {
        return new Observable<boolean | UrlTree>((observer) => {
          const parsedUrl = this.router.getCurrentNavigation()?.initialUrl;
          const queryParams = parsedUrl?.queryParamMap;
          const queryParamsObj: Record<string, string> = {};

          queryParams?.keys.forEach(key => {
            queryParamsObj[key] = queryParams!.get(key) || '';
          });

          queryParamsObj['next'] = url;
            if (this.authStore.initalRequest) {
                if (this.authStore.isUser(4)) {
                    observer.next(true);
                    observer.complete();
                } else {
                  observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
                  observer.complete();
                }
            } else {
                this.http.getCurrent().subscribe((val) => {
                    if (typeof val === 'string') {
                        this.authStore.userInfo = this.authStore.noAuth;
                        return;
                    }
                    this.authStore.userInfo = val.user;
                    if (this.authStore.isUser(4)) {
                        observer.next(true);
                        observer.complete();
                    } else {
                      observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
                      observer.complete();
                    }
                }, (error) => {
                  observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
                  observer.complete();
                });
            }
        });
    }
    canMatch = (route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> => {
        return this.guard(segments.join('/'));
    };
}

@Injectable()
export class LoginGuard  {
    constructor(private router: Router, private authStore: AuthStore, private http: AuthHttpService) { }
    guard(url: string): Observable<boolean | UrlTree> {
        return new Observable<boolean | UrlTree>((observer) => {
          const parsedUrl = this.router.getCurrentNavigation()?.initialUrl;
          const queryParams = parsedUrl?.queryParamMap;
          const queryParamsObj: Record<string, string> = {};

          queryParams?.keys.forEach(key => {
            queryParamsObj[key] = queryParams!.get(key) || '';
          });

          queryParamsObj['next'] = url;


          if (this.authStore.initalRequest) {
                if (this.authStore.isLoggedIn()) {
                    observer.next(true);
                    observer.complete();
                } else {
                  observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
                  observer.complete();
                }
            } else {
              console.log('here')
              console.log(url)
                this.http.getCurrent().subscribe((val) => {
                    if (typeof val === 'string') {
                        this.authStore.userInfo = this.authStore.noAuth;
                      observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
                      observer.complete();
                        return;
                    }
                    this.authStore.userInfo = val.user;
                    if (this.authStore.isLoggedIn()) {
                        observer.next(true);
                        observer.complete();
                    } else {
                      observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
                      observer.complete();
                    }
                }, (error) => {
                  observer.next(this.router.createUrlTree(['/login'], { queryParams: queryParamsObj }));
                  observer.complete();
                });
            }

        });

    }
    canMatch = (route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> => {
        return this.guard(segments.join('/'));
    };
}
